import { transferOrderIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod";
import { TransferDetailsSchema } from "./transfer-types";

export const getTransfer = {
  name: "getTransfer" as const,
  input: z.object({ transferId: transferOrderIdFormat.schema }),
  output: z.object({ transfer: TransferDetailsSchema }),
};
